import { colors } from "colors";
import styled from "styled-components";

interface TranscriptProps {
  video_url?: string;
}

export const TranscriptWrapper = styled.div<TranscriptProps>`
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  color: ${colors.black};
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: #f8f9fa;

  /* Modern scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${colors.mainGreen}40;
    border-radius: 4px;
  }

  /* Firefox scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: ${colors.mainGreen}40 transparent;

  .search-wrapper {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;

    .input-component {
      .input-label-container {
        input {
          width: 200px;
          height: 30px;
          font-size: 12px;
          padding: 0 10px;
        }
      }
    }
  }

  .top-section {
    display: flex;
    gap: 20px;
    height: 400px;
    min-height: 350px;
  }

  .video-wrapper {
    flex: 2.5;
    background-color: black;
    border-radius: 8px;
    overflow: hidden;
    position: relative;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .transcript-wrapper {
    flex: 1;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .transcript-header {
    padding: 15px 20px;
    border-bottom: 1px solid #e9ecef;
    background-color: #f8f9fa;
  }

  .transcript-content {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    font-size: 14px;
    line-height: 1.5;
  }

  .bottom-section {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }
`;

// Styled components for the transcript UI
export const TranscriptLine = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
`;

export const AvatarWrapper = styled.div`
  flex-shrink: 0;
  margin-right: 8px;
`;

export const Avatar = styled.div<{ color: string; textColor: string }>`
  background-color: ${({ color }) => color};
  color: ${({ textColor }) => textColor};
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
`;

export const MessageWrapper = styled.div`
  max-width: 90%;
  .message-content-wrapper {
    background-color: #f7f9fc;
    border-radius: 0 5px 5px 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    color: ${colors.black};
    padding: 8px 12px;
    font-size: 12px;
  }
`;

export const SpeakerName = styled.div`
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 2px;
`;

export const Timestamp = styled.span`
  font-size: 10px;
  color: ${colors.goodBlack};
  margin-left: 8px;
`;

// New styled components for call summary sections
export const CallSummarySection = styled.div`
  margin-bottom: 20px;
`;

export const SummaryText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.black};
  margin: 0;
`;

export const DurationSection = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.goodBlack};
  margin-bottom: 20px;
`;

export const CallChaptersSection = styled.div`
  margin-bottom: 20px;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.mainGreen};
  margin: 0 0 15px 0;
`;

export const ChapterItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background-color: #f8f9fa;
  border-radius: 6px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #e9ecef;
  }

  .chapter-title {
    font-size: 14px;
    font-weight: 500;
    color: ${colors.black};
  }

  .chapter-time {
    font-size: 12px;
    color: ${colors.goodBlack};
  }
`;

export const ActionItemsSection = styled.div`
  margin-bottom: 20px;
`;

export const ActionItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;

  .action-bullet {
    width: 8px;
    height: 8px;
    background-color: ${colors.mainGreen};
    border-radius: 50%;
    margin-right: 12px;
    margin-top: 6px;
    flex-shrink: 0;
  }

  .action-content {
    flex: 1;
  }

  .action-text {
    font-size: 14px;
    line-height: 1.5;
    color: ${colors.black};
    margin-bottom: 4px;
  }

  .action-assignee {
    font-size: 12px;
    color: ${colors.goodBlack};
    font-style: italic;
  }
`;

// Example mapping of avatars based on speakers
export const avatarColors: Record<string, string> = {
  Drew: "#E8A6A6", // Light red
  "Sam Maliska": "#D6B497", // Light brown
  // Add more speakers and colors as needed
};
